import { axios } from '@/utils/axios'
// import _ from 'lodash'
// import moment from 'moment'
import Storage from '@/assets/js/storage'

// 辅营产品列表
export async function queryProductsList (params) {
  try {
    return await axios.post('/api/order/extProduct/offerQuery', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 删除辅营
export async function removeProduct (params) {
  try {
    const result = await axios.post('/api/order/extProduct/remove', params)
    if (result.shoppingCartId) {
      Storage.setItem(`SHOPPINGCART_DATA`, result, 0.5 * 3600000)
    }
    return result
  } catch (error) {
    return Promise.reject(error)
  }
}

// 添加辅营
export async function addProduct (params) {
  try {
    const result = await axios.post('/api/order/extProduct/add', params)
    if (result) {
      Storage.setItem(`SHOPPINGCART_DATA`, result, 0.5 * 3600000)
    }
    return result
  } catch (error) {
    return Promise.reject(error)
  }
}

// 辅营-保险推送接口（航联）
export async function pushInsurance (params) {
  try {
    const result = await axios.post('/api/order/insurance/push', params)
    if (result) {
      Storage.setItem(`SHOPPINGCART_DATA`, result, 0.5 * 3600000)
    }
    return result
  } catch (error) {
    return Promise.reject(error)
  }
}

// 单独辅营 - 验证凭证信息
export async function validate (params) {
  try {
    return await axios.post('/api/mts/reserve/extract', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 单独辅营 - 索价
export async function fetchOffer (params) {
  try {
    return await axios.post('/api/mts/reserve/offer', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 单独辅营 - 下单
export async function placeOrder (params) {
  try {
    return await axios.post('/api/mts/reserve/placeOrder', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 单独辅营 - 支付方式
export async function fetchSelectPay (params) {
  try {
    return await axios.post('/api/mts/reserve/selectPay', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 单独辅营 - 优惠券校验
export async function validateAloneCoupon (params) {
  try {
    return await axios.post('/api/mts/reserve/validateCoupon', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 随票辅营 - 优惠券校验
export async function validateCoupon (params) {
  try {
    return await axios.post('/api/order/coupon/query', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 查询已购辅营产品
export async function fetchPurchased (params) {
  try {
    return await axios.post('/api/mts/order/bought', params)
  } catch (error) {
    return Promise.reject(error)
  }
}

// 校验单独辅营是否可以下单并获取提示
export async function checkExtraPlace (params) {
  try {
    return await axios.post('/api/mts/reserve/placeCheck', params)
  } catch (error) {
    return Promise.reject(error)
  }
}
